import { T } from "./tokens";

interface PlaylistTileProps {
  color: string;
  accent: string;
  title: string;
  sub?: string;
  badge?: string;
  height?: number;
  onClick?: () => void;
}

export function PlaylistTile({ color, accent, title, sub, badge, height = 132, onClick }: PlaylistTileProps) {
  return (
    <div
      onClick={onClick}
      className="nig-press nig-tap"
      role={onClick ? "button" : undefined}
      style={{
        position: "relative",
        height,
        borderRadius: T.r2,
        overflow: "hidden",
        background: `linear-gradient(155deg, ${color} 0%, ${T.navyDeep} 100%)`,
        padding: 14,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border: `1px solid ${T.hairline}`,
      }}
    >
      <svg
        style={{ position: "absolute", top: -30, left: -30, opacity: 0.55 }}
        width="120"
        height="120"
        viewBox="0 0 120 120"
      >
        {[20, 32, 44, 56].map((r) => (
          <circle key={r} cx="60" cy="60" r={r} stroke={accent} strokeOpacity="0.3" fill="none" />
        ))}
        <circle cx="60" cy="60" r="10" fill={accent} opacity="0.85" />
        <circle cx="60" cy="60" r="3" fill={T.navyDeep} />
      </svg>
      {badge ? (
        <div
          style={{
            alignSelf: "flex-start",
            padding: "2px 8px",
            borderRadius: 99,
            fontSize: 9.5,
            fontWeight: 600,
            background: `${accent}30`,
            color: accent,
            letterSpacing: "0.04em",
          }}
        >
          {badge}
        </div>
      ) : (
        <div />
      )}
      <div>
        <div
          style={{
            fontFamily: T.serif,
            fontSize: 16,
            fontWeight: 700,
            color: T.cream,
            lineHeight: 1.1,
          }}
        >
          {title}
        </div>
        {sub && (
          <div style={{ fontSize: 10.5, color: T.mist, marginTop: 4, lineHeight: 1.3 }}>{sub}</div>
        )}
      </div>
    </div>
  );
}
